import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResponse } from '@app/core/models/generic-response';
import { AppSettingsStore } from '@app/core/state/app-settings-store/app-settings-store';
import { DocumentDTO } from '@modules/registered-document-manager/models';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

interface RegisteredDocumentsPagedData {
    totalPages: number;
    totalItems: number;
    pageNumber: number;
    pageSize: number;
    items: DocumentDTO[];
}

@Injectable({
    providedIn: 'root',
})
export class DocumentRegisterService {
    private apiUrl = environment.apiRoot;

    constructor(private http: HttpClient, private appSettingsStore: AppSettingsStore) {}

    /**
     * Calls /documents/all with backend pagination parameters.
     * Keeps one endpoint contract for all registered-documents consumers.
     */
    getDocuments(
        page = 1,
        pageSize = 8
    ): Observable<GenericResponse<RegisteredDocumentsPagedData>> {
        const clientId = this.appSettingsStore.settings()?.user?.id || '';
        const user = this.appSettingsStore.settings()?.user?.name || '';
        const headers = new HttpHeaders({
            'X-ClientId': clientId,
            'X-User': user,
        });
        return this.http
            .get<GenericResponse<RegisteredDocumentsPagedData>>(
                `${this.apiUrl}documents/all?page=${page}&pageSize=${pageSize}`,
                { headers }
            )
            .pipe(
                map(resp => ({
                    ...resp,
                    data: {
                        ...resp.data,
                        items: resp.data?.items ?? [],
                    },
                }))
            );
    }

    /**
     * Convenience method for the register-documents page.
     * Returns paginated payload including items and total metadata.
     */
    getDocumentsForRegisterPage(
        page = 1,
        pageSize = 8
    ): Observable<RegisteredDocumentsPagedData> {
        return this.getDocuments(page, pageSize).pipe(
            map(
                (resp): RegisteredDocumentsPagedData =>
                    resp.data ?? {
                        totalPages: 0,
                        totalItems: 0,
                        pageNumber: page,
                        pageSize,
                        items: [],
                    }
            )
        );
    }

    getDocumentRegister$(): Observable<{}> {
        return of({});
    }
}
